define("powergen/views/keyboard-text-field",
  [],
  function() {
    "use strict";
    var keyboardTextField;

    keyboardTextField = Ember.TextField.extend({
      focusIn: function(event) {
        this._super();
        return this.sendAction('textFieldFocusIn', this, event);
      },
      focusOut: function(event) {
        this._super();
        return this.sendAction('textFieldFocusOut', this, event);
      },
      didInsertElement: function() {
        if (this.fieldName === "manager.user.firstName") {
          return this.$().focus();
        }
      }
    });


    return keyboardTextField;
  });